import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import SidebarMenu from "../components/SidebarMenu";
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../styles/layout.css';
import api from "../services/api";
import { useMountEffect } from "primereact/hooks";
import { statusFilterTemplate, statusBodyTemplate, imageBodyTemplate } from "../utils/filter_lib";
import EmployeeDialog from "../components/EmployeeDialog";

function EmployeesPage() {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const fetchEmployees = async () => {
    const res = await api.get("/users");
    setEmployees(res.data);
  };

  const header = <h3>Çalışanlar</h3>;
  const footer = `Toplam çalışan sayısı: ${employees.length}`;

  useMountEffect(() => {
    fetchEmployees();
  });

  const onRowClick = (e) => {
    setSelectedEmployee(e.data);
    setModalVisible(true);
  };

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <DataTable
          value={employees}
          header={header}
          footer={footer}
          paginator
          rows={20}
          stripedRows
          filterDisplay="row"
          onRowClick={onRowClick}>

          <Column header="Görsel" body={imageBodyTemplate} />
          <Column field="first_name" header="Ad" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
          <Column field="last_name" header="Soyad" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
          <Column field="email" header="Email" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
          <Column field="phone_number" header="Telefon" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
          <Column field="is_active" header="Durum" body={statusBodyTemplate} filter filterMatchMode="equals" filterElement={statusFilterTemplate} />
        </DataTable>

        <EmployeeDialog
          employee={selectedEmployee}
          visible={modalVisible}
          onHide={() => setModalVisible(false)}
        />
      </main>
    </div>
  );
}

export default EmployeesPage;
